import { render } from "./show_internet_state.vue?vue&type=template&id=22f8c486"
import script from "./show_internet_state.vue?vue&type=script&lang=js"
export * from "./show_internet_state.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__